import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { isServerSide } from '@atlassian/mpac-utils';
import { AlgoliaSearch } from '../../algolia';
import { BaseHandler } from '../../graphql-orchestrator-link';
import { getNlpSearchResults } from '../../search-service';
import { fetchFiltersBeforeSearchResults } from '../../utils';
import { transformFilters } from './utils/AlgoliaFiltersTransformUtil';
import { resolveAlgoliaSortIndexAndFilters } from './utils/AlgoliaSortUtil';
import { transposeAppsConnection } from './utils/AppTileTransposeUtil';
import { transformFiltersForNlpSearch, transformSortForNlpSearch } from './utils/NlpSearchFiltersTransformUtil';
export class SearchResultHandler extends BaseHandler {
  constructor(algoliaConfig, stargateBaseUrl, statsigClient, options) {
    super();
    _defineProperty(this, "algoliaConfig", void 0);
    _defineProperty(this, "stargateBaseUrl", void 0);
    _defineProperty(this, "statsigClient", void 0);
    _defineProperty(this, "options", void 0);
    this.algoliaConfig = algoliaConfig;
    this.stargateBaseUrl = stargateBaseUrl;
    this.statsigClient = statsigClient;
    this.options = options;
  }
  async fetchCustom(operation, _transformedOperation, _sequenceConfigValue, _primaryResponse) {
    var _this$options;
    const {
      query,
      filters,
      sort,
      after,
      first,
      additionalFilters,
      enableNLPSearch,
      environment,
      filterIds = [],
      search = ''
    } = operation.variables;
    const fetchFiltersFirst = isServerSide() && this.statsigClient && this.stargateBaseUrl;
    const finalAppliedFilters = fetchFiltersFirst ? await fetchFiltersBeforeSearchResults(filterIds, this.stargateBaseUrl, this.statsigClient, search, operation) : filters;

    //TODO: pass the new GC and IC filters in search API once the API model contracts are finalised.
    if (enableNLPSearch && (_this$options = this.options) !== null && _this$options !== void 0 && _this$options.useNlpSearch) {
      const response = await getNlpSearchResults({
        stargateBaseUrl: this.stargateBaseUrl,
        query,
        filter: transformFiltersForNlpSearch(finalAppliedFilters, environment),
        sort: transformSortForNlpSearch(sort),
        after,
        first
      });
      return response;
    } else {
      const {
        transformedAlgoliaIndex,
        sortFilters
      } = resolveAlgoliaSortIndexAndFilters(this.algoliaConfig.algoliaSearchIndex, sort, finalAppliedFilters);
      const facetFilters = transformFilters(finalAppliedFilters, sortFilters, additionalFilters);
      const response = await AlgoliaSearch({
        applicationId: this.algoliaConfig.algoliaAppId,
        apiKey: this.algoliaConfig.algoliaApiKey,
        indexName: transformedAlgoliaIndex,
        query,
        facetFilters,
        after,
        first
      });
      return response;
    }
  }
  responseTransformer(operation, _transformedOperation, _sequenceConfigValue, _primaryResponse, customResponse) {
    const newResponse = {
      marketplaceSearch: customResponse ? transposeAppsConnection({
        customResponse,
        query: operation.variables.query
      }) : null
    };
    return newResponse;
  }
}